import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "更新级别")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "指定版本")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最新版本")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required-item" }, "更新部门")
], -1)
const _hoisted_5 = { class: "organization-tree" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "更新级别")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "指定版本")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最新版本")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "app-update-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required-item" }, "更新部门")
], -1)
const _hoisted_10 = { class: "organization-tree" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_panel = _resolveComponent("panel")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, {
      gutter: 50,
      class: "app-update-setting"
    }, {
      default: _withCtx(() => [
        (_ctx.app.adaptiveSystem.includes(_ctx.ADAPTATION_SYSTEM_ENUM.ios))
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              xs: 24,
              sm: 24,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_panel, { title: "iOS 配置" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      model: _ctx.iOSNext.configValue,
                      ref: "iOSForm",
                      "label-width": "100px",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_alert, {
                              title: `线上版本：${_ctx.iOSOnline.configValue.latestVersion || '-'}`,
                              type: "warning",
                              closable: false,
                              "show-icon": ""
                            }, null, 8, ["title"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          prop: "updateLevel",
                          rules: [
                { required: true, message: '请选择更新级别' },
              ]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_1
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.iOSNext.configValue.updateLevel,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.iOSNext.configValue.updateLevel) = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "请选择",
                              class: "select-full"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.APP_UPDATE_LEVEL_LIST, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "specifyVersion",
                          rules: [
                { validator: (r, v, c) => _ctx.handleVersions(r, v, c, true),
                  trigger: 'blur' }
              ]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_2
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              placeholder: "请输入版本号（例：1.0.1）",
                              modelValue: _ctx.iOSNext.configValue.specifyVersion,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.iOSNext.configValue.specifyVersion) = $event)),
                              modelModifiers: { trim: true },
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"]),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          prop: "latestVersion",
                          rules: [
                { required: true, message: '最新版本不能为空' },
                { validator: (r, v, c) => _ctx.handleVersions(r, v, c),
                  trigger: 'blur' }
              ]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_3
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              placeholder: "请输入版本号（例：1.0.1）",
                              modelValue: _ctx.iOSNext.configValue.latestVersion,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.iOSNext.configValue.latestVersion) = $event)),
                              modelModifiers: { trim: true },
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"]),
                        (_ctx.app.updateDimension === _ctx.UPDATE_DIMENSION_ENUM.DEPARTMENT)
                          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                              label: _withCtx(() => [
                                _hoisted_4
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_el_tree, {
                                    data: _ctx.organizationTree,
                                    "show-checkbox": "",
                                    "default-expand-all": false,
                                    "node-key": "orgId",
                                    ref: "iOSTree",
                                    "highlight-current": "",
                                    props: _ctx.defaultProps
                                  }, null, 8, ["data", "props"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          label: "下载地址",
                          prop: "newDownloadUrl",
                          rules: [
                { required: true, message: '下载地址不能为空'},
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              disabled: true,
                              modelValue: _ctx.iOSNext.configValue.newDownloadUrl,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.iOSNext.configValue.newDownloadUrl) = $event)),
                              modelModifiers: { trim: true },
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          label: "更新日志",
                          prop: "changelog",
                          rules: [
                { required: true, message: '更新日志不能为空'},
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              rows: "6",
                              modelValue: _ctx.iOSNext.configValue.changelog,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.iOSNext.configValue.changelog) = $event)),
                              maxLength: 1000
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            (_ctx.$has(_ctx.permissionConfig.UPDATE))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm('iOSForm')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("保存 iOS 配置")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.app.adaptiveSystem.includes(_ctx.ADAPTATION_SYSTEM_ENUM.android))
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              xs: 24,
              sm: 24,
              md: 12,
              lg: 12,
              xl: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_panel, { title: "Android 配置" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      model: _ctx.androidNext.configValue,
                      ref: "androidForm",
                      "label-width": "100px",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_alert, {
                              title: `线上版本：${_ctx.androidOnline.configValue.latestVersion || '-'}`,
                              type: "warning",
                              closable: false,
                              "show-icon": ""
                            }, null, 8, ["title"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          prop: "updateLevel",
                          rules: [
                { required: true, message: '请选择更新级别' },
              ]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_6
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.androidNext.configValue.updateLevel,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.androidNext.configValue.updateLevel) = $event)),
                              modelModifiers: { trim: true },
                              placeholder: "请选择",
                              class: "select-full"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.APP_UPDATE_LEVEL_LIST, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "specifyVersion",
                          rules: [
                { validator: (r, v, c) => _ctx.handleVersions(r, v, c, true),
                  trigger: 'blur' }
              ]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_7
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              placeholder: "请输入版本号（例：1.0.1）",
                              modelValue: _ctx.androidNext.configValue.specifyVersion,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.androidNext.configValue.specifyVersion) = $event)),
                              modelModifiers: { trim: true },
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"]),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          prop: "latestVersion",
                          rules: [
                { required: true, message: '最新版本不能为空' },
                { validator: (r, v, c) => _ctx.handleVersions(r, v, c),
                  trigger: 'blur' }
              ]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_8
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              placeholder: "请输入版本号（例：1.0.1）",
                              modelValue: _ctx.androidNext.configValue.latestVersion,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.androidNext.configValue.latestVersion) = $event)),
                              modelModifiers: { trim: true },
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["rules"]),
                        (_ctx.app.updateDimension === _ctx.UPDATE_DIMENSION_ENUM.DEPARTMENT)
                          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                              label: _withCtx(() => [
                                _hoisted_9
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_component_el_tree, {
                                    data: _ctx.organizationTree,
                                    "show-checkbox": "",
                                    "default-expand-all": false,
                                    "node-key": "orgId",
                                    ref: "androidTree",
                                    "highlight-current": "",
                                    props: _ctx.defaultProps
                                  }, null, 8, ["data", "props"])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          label: "下载地址",
                          prop: "newDownloadUrl",
                          rules: [
                { required: true, message: '下载地址不能为空'},
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              disabled: true,
                              modelValue: _ctx.androidNext.configValue.newDownloadUrl,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.androidNext.configValue.newDownloadUrl) = $event)),
                              modelModifiers: { trim: true },
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          required: "",
                          label: "更新日志",
                          prop: "changelog",
                          rules: [
                { required: true, message: '更新日志不能为空'},
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              rows: "6",
                              modelValue: _ctx.androidNext.configValue.changelog,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.androidNext.configValue.changelog) = $event)),
                              maxLength: 1000
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            (_ctx.$has(_ctx.permissionConfig.UPDATE))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.submitForm('androidForm')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("保存 Android 配置")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}